import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Form, InputGroup, Modal } from "react-bootstrap";
import { FaSearch } from "react-icons/fa";
import { FiUpload, FiPlus } from "react-icons/fi";
import { useTranslation } from "react-i18next";

import { fetchDelegations } from "../../../redux/slices/delegationSlice";
import { sortAlphabetically } from "../../../utils/sortAlphabetically";
import CreateDelegationModal from "../../Modal/DelegationModal/CreateDelegationModal/CreateDelegationModal";
import DelegacoesTable from "../../tables/DelegationTable/DelegationTable";

const DelegationsTab = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  
  const delegations = useSelector((state) => state.delegations?.items);
  const sortedDelegations = useMemo(
    () => sortAlphabetically(delegations || [], (delegation) => [delegation.name], i18n.language),
    [delegations, i18n.language],
  );
  const [searchTerm, setSearchTerm] = useState("");
  const [showCreateModal, setShowCreateModal] = useState(false);

  useEffect(() => {
    dispatch(fetchDelegations());
  }, [dispatch]);

  return (
    <div className="delegations-tab-container">
      {/* Header Toolbar */}
      <div className="d-flex justify-content-between align-items-end mb-4 pb-2 border-bottom">
        <h4 className="txt-main fw-bold m-0">{t("components.DelegationsTab.title")}</h4>
        
        <div className="d-flex gap-2">
          <Button variant="light" className="bg-surface txt-subtle shadow-sm">
            <FiUpload size={16} /> {t("components.DelegationsTab.import")}
          </Button>
          <Button
            variant="outline-danger"
            className="shadow-sm"
            onClick={() => setShowCreateModal(true)}
          >
            <FiPlus size={18} /> {t("components.DelegationsTab.newDelegation")}
          </Button>
        </div>
      </div>

      {/* Search Input */}
      <div className="atlar-card mb-4">
        <InputGroup className="shadow-none p-2">
          <InputGroup.Text className="bg-transparent border-0">
            <FaSearch className="txt-subtle" />
          </InputGroup.Text>
          <Form.Control
            type="text"
            placeholder={t("components.DelegationsTab.search")}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="border-0 shadow-none"
          />
        </InputGroup>
      </div>

  
      <DelegacoesTable 
        delegations={sortedDelegations} 
        searchTerm={searchTerm}
        onRefresh={() => dispatch(fetchDelegations())} 
      />

      <Modal
        show={showCreateModal}
        onHide={() => setShowCreateModal(false)}
        centered
        backdrop="static"
        contentClassName="text-white"
        style={{ "--bs-modal-bg": "#17296B" }}
      >
        <CreateDelegationModal onClose={() => setShowCreateModal(false)} />
      </Modal>
    </div>
  );
};

export default DelegationsTab;
